//-----------------------------|| LIST ||---------------------------------------------------------------
export const SET_CUSTOMER_LIST = 'SET_CUSTOMER_LIST';
export const CLEAR_CUSTOMER_LIST = 'CLEAR_CUSTOMER_LIST';
export const CUSTOMER_LIST_PENDING = 'CUSTOMER_LIST_PENDING';
export const CUSTOMER_LIST_ERROR = 'CUSTOMER_LIST_ERROR';
export const CUSTOMER_LIST_ERROR_CLEAR = 'CUSTOMER_LIST_ERROR_CLEAR';

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const CUSTOMER_FILTER_DIALOG_OPEN = 'CUSTOMER_FILTER_DIALOG_OPEN';
export const CUSTOMER_FILTER_DIALOG_CLOSE = 'CUSTOMER_FILTER_DIALOG_CLOSE';
export const SET_CUSTOMER_FILTER_DATA = 'SET_CUSTOMER_FILTER_DATA';

//-----------------------------|| DETAILS ||------------------------------------------------------------
export const SET_CUSTOMER_DETAILS = 'SET_CUSTOMER_DETAILS';
export const CLEAR_CUSTOMER_DETAILS = 'CLEAR_CUSTOMER_DETAILS';
export const CUSTOMER_DETAILS_PENDING = 'CUSTOMER_DETAILS_PENDING';
export const CUSTOMER_DETAILS_ERROR = 'CUSTOMER_DETAILS_ERROR';
export const CUSTOMER_DETAILS_ERROR_CLEAR = 'CUSTOMER_DETAILS_ERROR_CLEAR';

//-----------------------------|| CREATE ||-------------------------------------------------------------
export const CUSTOMER_CREATE_DIALOG_OPEN = 'CUSTOMER_CREATE_DIALOG_OPEN';
export const CUSTOMER_CREATE_DIALOG_CLOSE = 'CUSTOMER_CREATE_DIALOG_CLOSE';
export const CUSTOMER_CREATE_PENDING = 'CUSTOMER_CREATE_PENDING';
export const CUSTOMER_CREATE_ERROR = 'CUSTOMER_CREATE_ERROR';
export const CUSTOMER_CREATE_ERROR_CLEAR = 'CUSTOMER_CREATE_ERROR_CLEAR';

//-----------------------------|| EDIT ||---------------------------------------------------------------
export const CUSTOMER_EDIT_DIALOG_OPEN = 'CUSTOMER_EDIT_DIALOG_OPEN';
export const CUSTOMER_EDIT_DIALOG_CLOSE = 'CUSTOMER_EDIT_DIALOG_CLOSE';
export const CUSTOMER_EDIT_PENDING = 'CUSTOMER_EDIT_PENDING';
export const CUSTOMER_EDIT_ERROR = 'CUSTOMER_EDIT_ERROR';
export const CUSTOMER_EDIT_ERROR_CLEAR = 'CUSTOMER_EDIT_ERROR_CLEAR';